<template>
  <v-container no-gutters>
    <v-row no-gutters class="pb-6">
      <v-col>
        <img ref="logo" style="max-height:220px" :src="url" />
      </v-col>
    </v-row>
    <v-row no-gutters class="justify-center pb-6">
      <v-col cols="auto">
        <v-subheader class="text-h6 pa-0 font--text font-weight-regular" style="height: auto;">
          {{ appName }}
        </v-subheader>
      </v-col>
    </v-row>
    <v-row no-gutters class="justify-center align-center">
      <v-col cols="auto" class="pr-3">
        <main-loader />
      </v-col>
      <v-col cols="auto"> {{ $i18n.t('login.ukeLoginLoading') }} </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { call, get } from 'vuex-pathify';
import MainLoader from '@/components/MainLoader';
export default {
  name: 'LoginUke',
  components: { MainLoader },
  computed: {
    appName: get('admin/settingsValues@app_name'),
    tokenUke() {
      return this.$route.query.ott || '';
    },
  },
  data: () => ({
    url: `${process.env.VUE_APP_API_URL}/settings/logo`,
  }),
  methods: {
    loginUke: call('authentication/loginUke'),
    async loginToUke() {
      if (this.tokenUke) {
        try {
          await this.loginUke({ credentials: { token: this.tokenUke } });
          this.$router.push({ name: 'map' });
        } catch {
          this.$router.push({ name: 'login' });
        }
      } else {
        this.$router.push({ name: 'login' });
      }
    },
  },
  mounted() {
    this.loginToUke();
  },
};
</script>
